import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applySeo } from '../lib/seo';

// Keeps <head> in step with the route. Renders nothing.
const SeoHead = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    applySeo(pathname);
  }, [pathname]);
  return null;
};

export default SeoHead;
